import { useState } from 'react';

/** Keeps the last non-null value so a collapsing field shows it until closed. */
export function useLastShown<T>(value: T | null): T | null {
  const [last, setLast] = useState(value);
  if (value !== null && value !== last) {
    setLast(value);
  }
  return value ?? last;
}
